module.exports = __webpack_public_path__ + "static/media/modal-close.31e9c392.png";